'use client';
import { useParams } from 'next/navigation';

import ContentImage from './~components/ContentImage';
import ContentText from './~components/ContentText';
import ContentTitle from './~components/ContentTitle';
// import ContentTitle from './~components/ContentTitle';
import ContentVideo from './~components/ContentVideo';

import { Container } from '@/components/design/container';
import { Skeleton } from '@/components/ui/skeleton';
import useContentBankItem from '@/hooks/queries/useContentBankItem';

export default function Content(): React.ReactElement {
  type RouteParams = {
    id: string;
  };
  const { id } = useParams<RouteParams>();

  const { data, isFetched } = useContentBankItem({ id });

  if (isFetched && !data) {
    return <></>;
  }

  if (!isFetched) {
    return (
      <Container className="flex flex-col space-y-3 mt-6">
        <Skeleton className="h-[125px] w-full rounded-xl" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
        </div>
      </Container>
    );
  }

  return data ? (
    <Container className="flex flex-col gap-6 mt-6">
      {data.title && <ContentTitle title={data.title} />}
      {data.files.length > 0 && (
        <div className="min-h-50">
          <ContentImage images={data.files} content_id={data.id} />
        </div>
      )}
      {data.videos?.length > 0 &&
        data?.videos.map((item, index) => (
          <div className="min-h-50" key={index}>
            <ContentVideo
              link={item.video_link}
              cover={item.video_cover_image}
            />
          </div>
        ))}
      {(data.description || data.hashtags) && (
        <ContentText
          caption={data.description || ''}
          hashtags={data.hashtags || ''}
          content_id={data.id}
        />
      )}
    </Container>
  ) : (
    <></>
  );
}
